import { createStore } from 'hox';
import { useState } from 'react';
import { MultiTenant } from '@Types/index';

function useMultiTenants() {
  const [multiTenants, setMultiTenants] = useState<MultiTenant[] | null>(null);
  return {
    multiTenants,
    setMultiTenants,
  };
}
export const [useMultiTenantsStore, MultiTenantsProvider] =
  createStore(useMultiTenants);
